// extracted by mini-css-extract-plugin
module.exports = {"boxSearch":"_2T3INSGD0Zfg8rgwAa8Qc5","boxInput":"_3aCQeoeLG0nc8IIwYYU0lO","inputSearch":"_1mt9BJkPr8es-t4hWCbLxe"};